var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPythonLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_123_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6273 0.0249023C21.3413 0.0249023 22.7328 9.72733 22.7328 9.72733L22.7576 19.7793H44.0247V22.7972H14.3106C14.3106 22.7972 0.0498047 21.1735 0.0498047 43.7481C0.0498047 66.3234 12.497 65.5228 12.497 65.5228H19.9254V55.047C19.9254 55.047 19.525 42.551 32.1739 42.551H53.2671C53.2671 42.551 65.1179 42.7432 65.1179 31.0527V11.723C65.1179 11.723 66.9178 0.0249023 43.6273 0.0249023ZM31.9007 6.78468C32.4032 6.78423 32.9009 6.88327 33.3653 7.07613C33.8297 7.269 34.2516 7.5519 34.607 7.90866C34.9624 8.26541 35.2442 8.68901 35.4363 9.15522C35.6284 9.62143 35.727 10.1211 35.7266 10.6256C35.727 11.1302 35.6284 11.6298 35.4363 12.096C35.2442 12.5622 34.9624 12.9858 34.607 13.3426C34.2516 13.6993 33.8297 13.9823 33.3653 14.1751C32.9009 14.368 32.4032 14.467 31.9007 14.4666C31.3981 14.467 30.9004 14.368 30.436 14.1751C29.9716 13.9823 29.5497 13.6993 29.1943 13.3426C28.8389 12.9858 28.5571 12.5622 28.365 12.096C28.1729 11.6298 28.0743 11.1302 28.0747 10.6256C28.0743 10.1211 28.1729 9.62143 28.365 9.15522C28.5571 8.68901 28.8389 8.26541 29.1943 7.90866C29.5497 7.5519 29.9716 7.269 30.436 7.07613C30.9004 6.88327 31.3981 6.78423 31.9007 6.78468V6.78468Z",
    fill: "url(#paint0_linear_123_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2602 87.6984C66.5462 87.6984 65.1547 77.996 65.1547 77.996L65.13 67.9443H43.8625V64.9264H73.5766C73.5766 64.9264 87.8374 66.5501 87.8374 43.9748C87.8374 21.3999 75.3902 22.2005 75.3902 22.2005H67.9618V32.676C67.9618 32.676 68.3622 45.172 55.7133 45.172H34.6201C34.6201 45.172 22.7693 44.9798 22.7693 56.6707V76.0006C22.7693 76.0006 20.9698 87.6984 44.2599 87.6984H44.2602ZM55.9869 80.9393C55.4843 80.9398 54.9866 80.8407 54.5222 80.6479C54.0578 80.455 53.6359 80.1721 53.2805 79.8154C52.9252 79.4586 52.6434 79.035 52.4513 78.5688C52.2592 78.1026 52.1605 77.6029 52.161 77.0984C52.1605 76.5938 52.2591 76.0941 52.4512 75.6279C52.6433 75.1616 52.9251 74.738 53.2804 74.3812C53.6358 74.0244 54.0577 73.7415 54.5222 73.5486C54.9866 73.3557 55.4843 73.2566 55.9869 73.2571C56.4894 73.2566 56.9872 73.3557 57.4515 73.5485C57.9159 73.7414 58.3379 74.0243 58.6932 74.3811C59.0486 74.7378 59.3304 75.1614 59.5225 75.6276C59.7146 76.0938 59.8133 76.5935 59.8128 77.098C59.8133 77.6026 59.7146 78.1022 59.5225 78.5684C59.3304 79.0346 59.0486 79.4582 58.6932 79.815C58.3379 80.1718 57.9159 80.4547 57.4515 80.6475C56.9872 80.8404 56.4894 80.9394 55.9869 80.939V80.9393Z",
    fill: "url(#paint1_linear_123_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_123_2",
    x1: 8.48616,
    y1: 7.91061,
    x2: 52.1596,
    y2: 50.9794,
    "gradient-units": "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_123_2",
    x1: 35.1895,
    y1: 35.6766,
    x2: 82.0812,
    y2: 79.8317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_123_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonLogo);
export default __webpack_public_path__ + "static/media/python_logo.206cae51eb67c9230ab7c1e50dd4e321.svg";
export { ForwardRef as ReactComponent };